export default __webpack_public_path__ + "static/avatars-dark-9eb5ed71845cc1a2c3bd24415353296e.png";